import { render, staticRenderFns } from "./AtomTitleAndDescription.vue?vue&type=template&id=542cd856&scoped=true&"
import script from "./AtomTitleAndDescription.vue?vue&type=script&lang=js&"
export * from "./AtomTitleAndDescription.vue?vue&type=script&lang=js&"
import style0 from "./AtomTitleAndDescription.vue?vue&type=style&index=0&id=542cd856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542cd856",
  null
  
)

export default component.exports